var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-box"},[_c('home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }